import React from "react";
import { Link } from "react-router-dom";

import logo from "../htdocs/images/logo.png";
import logoMini from "../htdocs/images/logo-mini.png";
import profilePhoto from "../htdocs/images/faces/face28.png";

function Navbar() {

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login"
  }

  return (
    <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <a className="navbar-brand brand-logo" href="/">
          <img src={logo} alt="logo" />
        </a>
        <a className="navbar-brand brand-logo-mini" href="/">
          <img src={logoMini} alt="logo" />
        </a>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
        <button
          className="navbar-toggler navbar-toggler align-self-center"
          type="button"
          data-toggle="minimize"
        >
          <span className="mdi mdi-menu"></span>
        </button>
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item nav-profile dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="/#"
              data-toggle="dropdown"
              id="profileDropdown-navbar"
            >
              <span className="nav-profile-name">Jesús</span>
              <span className="online-status"></span>
              <img src={profilePhoto} alt="profile" />
            </a>
            <div
              className="dropdown-menu dropdown-menu-right navbar-dropdown"
              aria-labelledby="profileDropdown-navbar"
            >
              <Link className="dropdown-item" to="/profile">
                <i className="mdi mdi-face text-primary"></i>
                Profile
              </Link>
              <button className="dropdown-item" onClick={handleLogout}>
                <i className="mdi mdi-logout text-primary"></i>
                Logout
              </button>
            </div>
          </li>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          data-toggle="offcanvas"
        >
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
  );
}

export { Navbar };
